module.exports = __webpack_public_path__ + "img/finland-flag-round-small.44f1501c.png";